export default {
  getJobListing: (state) => state.jobListing,
  activeJobListings: (state) => state.jobListings,
};
